import { useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", notify);
      return () => list.removeEventListener("change", notify);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** Persistent sidebar from 1024 CSS px: desktops and iPads in landscape. Narrower widths get a drawer. */
export const WIDE_QUERY = "(min-width: 64rem)";

/** Below this (iPads and small laptops) the sidebar starts as an icon rail, because the screens need the width more. */
export const RAIL_QUERY = "(max-width: 85.3125rem)";
